
import { booleanProp } from '@/mixins'
import { defineComponent, ref, watch } from 'vue'
export default defineComponent({
  name: 'FrModal',
  props: {
    modelValue: booleanProp(false),
    size: {
      type: String,
      default: () => 'default'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const modalContainer = ref<any>(null)
    const isModalOpen = ref(props.modelValue)

    const transitionEnter = (el: any, done: () => void): void => {
      // // console.log('entra', el)
      done()
    }
    const transitionLeave = (el: any, done: () => void): void => {
      // // console.log('entra', el)
      done()
    }
    const closeModal = () => {
      isModalOpen.value = !isModalOpen.value
      emit('update:modelValue', isModalOpen.value)
    }

    watch(
      () => props.modelValue,
      (first: boolean, second: boolean) => {
        // // console.log('cambio modelo', first, second)
        isModalOpen.value = props.modelValue
      }
    )

    return {
      modalContainer,
      isModalOpen,
      closeModal,
      transitionEnter,
      transitionLeave
    }
  }
})
